import React from 'react';
import './Modal.scss';

const Modal = (props) => (
  <div className="custom-modal">

    {
      props.isOpen ?
      <section className="content">
        {props.children}
        <button onClick={props.closeCallback}>{props.closeButtonText}</button>
      </section> :
      ''
    }
  </div>
);

export default Modal;